import store from '../store/store'
import { HttpClient } from '@/components/shared/http-client'
import router from '../router'
let lastRoute = null
const secondsBetweenPoll = 300
/*
  Polls the backend for new tasks on every route change or every [secondsBetweenPoll] seconds
*/
function timeForNextCall() {
  return (new Date().getTime() - lastRoute) / 1000 >= secondsBetweenPoll - 1
}

function getAccountCode() {
  return router?.history.current.params.accountId || router?.history.current.params.accountCode
}

async function fetchTasks(route = false) {
  const accountCode = getAccountCode()
  if (accountCode && store.getters.isLoggedIn && (route || timeForNextCall)) {
    try {
      const { data } = await HttpClient.get(`/api/accounts/${accountCode}/tasks`)
      store.commit('SET_ACCOUNT_TASKS', data)
    } catch (error) {
      console.log('Failed to fetch tasks', error)
    }
  } else {
    store.commit('SET_ACCOUNT_TASKS', [])
  }
}

setInterval(fetchTasks, secondsBetweenPoll * 1000)

export default () => {
  lastRoute = new Date().getTime()
  fetchTasks(true).then()
}
